const getPrescriberLIC = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber.LIC) {
    return prescriber.LIC;
  }
  if (patient.Prescriber[0]) {
    return patient.Prescriber[0].LIC;
  }
  return null;
};

export default getPrescriberLIC;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberLIC.js